import React from 'react';
import { connect } from 'dva';
import curry from 'lodash-es/curry';
import get from 'lodash-es/get';
import PropTypes from 'prop-types';
import { SIDEBAR_SAVED_TABS } from '../../../lib/constants'
import SavedContentTabContent from './SavedContentTabContent';
import SavedHuntTabContent from './SavedHuntTabContent';
import TabBar from '../../TabBar';

function SavedContent(props) {
  const tabClicked = curry((tabName, e) => {
    props.dispatch({
      type: 'app/updateMetadata',
      payload: { savedContentTab: tabName }
    });
    props.dispatch({
      type: 'features/resetAllSelectedFeatures'
    });
    let dispatchType = null
    switch(tabName) {
      case SIDEBAR_SAVED_TABS.Collection:
        dispatchType = 'collections/setCollectionsLoading'
      break
      case SIDEBAR_SAVED_TABS.Content:
        dispatchType = 'features/setFeaturesLoading'
      break
    }
    props.dispatch({
      type: dispatchType,
      payload: true
    });
    setTimeout(() => {
      props.dispatch({
        type: dispatchType,
        payload: false
      });
    }, 50)
  });

  /*
    #TODO: Refactor into something more React-y
    -- TJC - April 27, 2020
  */
  const tabBarItems = {
    [SIDEBAR_SAVED_TABS.Collection]: {
      title: 'Hunts',
      component: <SavedHuntTabContent />,
      onClick: tabClicked(SIDEBAR_SAVED_TABS.Collection)
    },
    [SIDEBAR_SAVED_TABS.Content]: {
      title: 'Content',
      component: <SavedContentTabContent />,
      onClick: tabClicked(SIDEBAR_SAVED_TABS.Content)
    },
  };
  return (
    <>
      <TabBar tab={props.tab} tabBarItems={tabBarItems} />
      {tabBarItems[props.tab].component}
    </>
  );
}


SavedContent.propTypes = {
  tab: PropTypes.string
};

export default connect((model) => {
  return {
    /*
      #TODO: Separate model for this sidebar? For each sidebar?
      -- TJC - April 27, 2020
    */
    tab: get(model.app.sidebarView, ['metadata', 'savedContentTab'], SIDEBAR_SAVED_TABS.Collection)
  };
})(SavedContent);
